import { createApp } from "vue";
import App from "./App.vue";
import Maska from "maska";
import router from "./router/router";
//import Popper from "popper.js";
//import jquery from "jquery";
//import bootstrap from "bootstrap";
//import BootstrapVue3 from 'bootstrap-vue-3';


import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/css/style.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
//Vue.use(bootstrap);
//Vue.use(jquery);
//vuex store
import store from "./stores/index";

///vue toaser
import VueToast from "vue-toast-notification";
///VueLoading
import VueLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import "vue-toast-notification/dist/theme-sugar.css";
///firebase
// import firebase from "firebase";

///VueI18n
import { createI18n } from "vue-i18n";
import en from "./translations/en.json";
import kh from "./translations/kh.json";

///VueSweetalert2
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const messages = {
  en: en,
  kh: kh
};

const lang = store.state.lan || "kh";

//console.log(lang);

const i18n = createI18n({
  locale: lang, // set locale
  //fallbackLocale: "en", // set fallback locale
  messages // set locale messages
  // If you need to specify other options, you can set other options
  // ...
});

// const firebaseConfig = {
//   apiKey: "AIzaSyAC6DPEUlbQx9zj75_WPqGprN0qRN0DMWw",
//   authDomain: "phone-auth-87b0f.firebaseapp.com",
//   projectId: "phone-auth-87b0f",
//   storageBucket: "phone-auth-87b0f.appspot.com",
//   messagingSenderId: "388846710633",
//   appId: "1:388846710633:web:6ed6dd97eee562457117f8",
//   measurementId: "G-3QEDVJWHZM"
// };

// firebase.initializeApp(firebaseConfig);
// firebase.analytics();
//
const app = createApp(App);
///vuex store
app.use(store);
///router
app.use(router);
///mask
app.use(Maska);
//toaser
app.use(VueToast);
//VueLoading
app.use(VueLoading);
//VueI18n
app.use(i18n);
//app.use(bootstrap);
///VueSweetalert2
const options = {
  confirmButtonColor: "#41b882",
  cancelButtonColor: "#ff7674"
};
app.use(VueSweetalert2, options);
app.mount("#app");
